import classNames from "classnames";
import PropTypes from "prop-types";
import { ReactComponent as CheckIcon } from "../Assets/icons/check.svg";
import { ReactComponent as CloseIcon } from "../Assets/icons/close_small.svg";

const Toggle = ({ checked, onChange, disabled = false, className }) => {
  const handleClick = () => {
    if (!disabled) {
      onChange(!checked);
    }
  };

  return (
    <button
      type="button"
      className={classNames("miltis__toggle", className, {
        "miltis__toggle--checked": checked,
        "miltis__toggle--disabled": disabled,
      })}
      onClick={handleClick}
      disabled={disabled}
    >
      <div className="miltis__toggle--thumb">
        {checked ? <CheckIcon /> : <CloseIcon />}
      </div>
    </button>
  );
};

Toggle.propTypes = {
  checked: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  className: PropTypes.string,
};

Toggle.defaultProps = {
  checked: false,
  disabled: false,
};

export default Toggle;
